import { Globe, Database, Search, MapPin, Zap, Hammer } from "lucide-react";
import { ChapterLabel } from "./ChapterLabel";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    icon: Globe,
    title: "Website Performance",
    text: "We check if your site is actually turning visitors into calls and customers.",
    span: "md:col-span-3",
  },
  {
    icon: Database,
    title: "CRM & Lead Tracking",
    text: "We make sure leads aren't slipping through the cracks.",
    span: "md:col-span-3",
  },
  {
    icon: Search,
    title: "Google Search Ranking",
    text: "We track how you rank on Google and what's holding you back.",
    span: "md:col-span-2",
  },
  {
    icon: MapPin,
    title: "Google Business Profile",
    text: "We optimize your listing so you show up when people search nearby.",
    span: "md:col-span-2",
  },
  {
    icon: Zap,
    title: "Speed to Lead",
    text: "We measure how fast you respond to new inquiries — the #1 factor in winning the job.",
    span: "md:col-span-2",
  },
  {
    icon: Hammer,
    title: "Website Design & Build",
    text: "Need a site or a rebuild? We design and build fast, mobile-first websites for service businesses — built to turn visitors into calls, not just look pretty.",
    span: "md:col-span-6",
  },
];

export const Services = () => (
  <section id="whats-included" className="py-24 sm:py-32 bg-[#0B162B]/40" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterLabel text="Chapter 03 // What's Included" />
        <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-tight text-white mb-16">
          What's Included
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-6 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className={s.span}>
            <div
              data-testid={`service-card-${i + 1}`}
              className="group h-full rounded-2xl sm:rounded-3xl border border-white/10 bg-[#0F1B31]/70 p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-white/30 hover:bg-[#12203a]/80"
            >
              <span className="mb-8 inline-flex h-12 w-12 items-center justify-center rounded-full border border-white/15 bg-white/[0.05] text-white transition-colors duration-300 group-hover:bg-white group-hover:text-[#060D1A]">
                <s.icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-white mb-3">
                {s.title}
              </h3>
              <p className="text-base text-slate-400 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
